/**
 * Header Give Button - active/focus state fix
 *
 * Inline styles set via JS have higher priority than any injected stylesheet
 * (including custom_head_html from ThemeOptionsManager), so this is the only
 * reliable way to guarantee white text on blue background when the button is
 * held down or focused, regardless of what other CSS may be on the page.
 */
(function () {
  'use strict';

  function initHeaderGiveBtn() {
    var buttons = document.querySelectorAll('.btn--header-give');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      // Mousedown: force blue bg + white text instantly
      btn.addEventListener('mousedown', function () {
        btn.style.setProperty('background-color', 'var(--c-blue)', 'important');
        btn.style.setProperty('color', '#ffffff', 'important');
        btn.style.setProperty('border-color', 'var(--c-blue)', 'important');
      });

      // Mouseup + mouseleave: restore normal appearance
      function clearActive() {
        btn.style.removeProperty('background-color');
        btn.style.removeProperty('color');
        btn.style.removeProperty('border-color');
      }

      btn.addEventListener('mouseup', clearActive);
      btn.addEventListener('mouseleave', clearActive);

      // Focus (keyboard nav): same treatment
      btn.addEventListener('focus', function () {
        btn.style.setProperty('background-color', 'var(--c-blue)', 'important');
        btn.style.setProperty('color', '#ffffff', 'important');
        btn.style.setProperty('border-color', 'var(--c-blue)', 'important');
      });

      btn.addEventListener('blur', clearActive);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderGiveBtn);
  } else {
    initHeaderGiveBtn();
  }
})();
